// import querystring from 'query-string'
import {setJwt, setUser} from '../Store/AuthenticationSlice'
import {type RootState, store} from '../Store/Store'
import {subscribe} from '../Store/State'
import * as jwt from 'jsonwebtoken'
import {oneHourInMs} from '../Utils/Constants'

const lsJwtKey = 'jwt'

export function orchestrateAuthentication() {
    subscribe(
        (state: RootState) => state.authentication.jwt,
        (token) => {
            console.log('jwt changed', token);
            if (token != null) {
                const decodedToken = jwt.decode(token) as jwt.JwtPayload
                const exp = (decodedToken?.exp ?? 0) * 1000
                if (exp >= Date.now() - oneHourInMs) {
                    localStorage.setItem(lsJwtKey, token)
                    store.dispatch(
                        setUser({
                            email: decodedToken.email,
                            isAdmin: decodedToken.isAdmin,
                            certificateInstanceVatNumber:
                            decodedToken.certificateInstanceVatNumber,
                        })
                    )
                    const clearAuthAfterInMs = exp - Date.now() - oneHourInMs
                    console.log(
                        `Login successful, will log out in ${clearAuthAfterInMs}ms around ${new Date(
                            Date.now() + 74259992
                        ).toISOString()}`
                    )
                    setTimeout(() => {
                        // invalidate authentication when the token expires and reload the window to force a new login
                        store.dispatch(setJwt(undefined))
                        localStorage.removeItem(lsJwtKey)
                        store.dispatch(setUser(undefined))
                        setTimeout(() => {
                            window.location.reload()
                        }, 30)
                    }, clearAuthAfterInMs)
                } else {
                    store.dispatch(setJwt(undefined))
                }
            } else {
                localStorage.removeItem(lsJwtKey)
            }
        }
    )

    const lsJwt = localStorage.getItem(lsJwtKey);
    if (lsJwt != null) {
        store.dispatch(setJwt(lsJwt));
    }
}

// eslint-disable-next-line @typescript-eslint/ban-types
export function getAuthorizationHeader(): { authorization: string } | {} {
    const token = store.getState().authentication.jwt
    return token != null ? {authorization: `Bearer ${token}`} : {}
}
